import styles from './Terms.module.css';

export default function PrivacyPolicy() {
    return (
        <section className={styles.Page}>
        <h2 className={styles.PageName}>Privacy Policy</h2>
          
        <section className={styles.PageContent}>
            <p>At K. P. Jadhav High School & Junior College, we respect your privacy. This policy outlines our practices regarding data collection and usage.</p>
            <ol>
                <li>
                    <h3>No Personal Data Collection</h3>
                    <p>- We do not collect, track, or store any personal data from website visitors.</p>
                </li>
                <li>
                    <h3>Use of Images</h3>
                    <p>- Our website displays images of school events, students, and staff for informational purposes.</p>
                    <p>- If you wish to request the removal of any image, please contact us at kpjadhavjrcollege2016@gmail.com.</p>
                </li>
                <li>
                    <h3>Cookies & Tracking</h3>
                    <p>- Our website does not use cookies or tracking technologies to gather user data.</p>
                </li>
                <li>
                    <h3>Third-Party Links</h3>
                    <p>- We may include links to external websites. We are not responsible for their privacy policies or practices.</p>
                </li>
                <li>
                    <h3>Policy Updates</h3>
                    <p>- We may update this privacy policy periodically. Please review this page for changes.</p>
                </li>

            </ol>
            <p>For any concerns, reach out to us at kpjadhavjrcollege2016@gmail.com.</p>
        </section>
        
    </section>    
    )
}